import { toErrorWithMessage } from '@tuic/lib/helpers/error';

export const createFetchWithTimeout = (
  timeoutInMsOrTimeoutResolver: number | ((req: Request) => number),
) => {
  return async (request: Request) => {
    try {
      const resolvedTimeout =
        typeof timeoutInMsOrTimeoutResolver === 'number'
          ? timeoutInMsOrTimeoutResolver
          : timeoutInMsOrTimeoutResolver(request);

      return await fetch(request, {
        signal: AbortSignal.timeout(resolvedTimeout),
        next: {
          revalidate: 0,
        },
      });
    } catch (err) {
      let errorWithMessage = toErrorWithMessage(err);
      let body = `[ApiKitError] ${errorWithMessage.name} -- ${errorWithMessage.message} -- ${request.method} ${request.url}`;

      if (errorWithMessage.name.includes('TimeoutError')) {
        return new Response(body, {
          status: 408,
          statusText: 'Request Timeout',
        });
      }

      return new Response(body, {
        status: 400,
        statusText: 'Bad Request',
      });
    }
  };
};
